import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Platform } from '@ionic/angular';
import { AngularFireDatabase, AngularFireList, AngularFireObject } from '@angular/fire/database';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { AngularFireStorage } from '@angular/fire/storage';
import { ModalController } from '@ionic/angular';
import { Emergency } from '@app/core/db/emergency.model';
import { FollowsheetComponent } from '@app/shared/followsheet/followsheet.component';
import { AgmComponent } from '@app/shared/agm/agm.component';
import { ShellComponent } from '@app/shell/shell.component';
import { Observable, Subscription } from 'rxjs';
import { AuthenticationService } from '@app/core';
import { ApiService } from '@app/shared/services/api/api.service';
import { environment } from '@env/environment';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  @ViewChild(AgmComponent, {
    static: true
  })
  agmComponent: AgmComponent;
  segmentSelected = 'alerts';
  loadingstate = true;
  circlesRef: AngularFireList<any>;
  circles: Observable<any[]>;
  emergencies: Emergency[] = [];
  follows: any[] = [];
  listEmergencies = this.shellComponent.switch;
  activeFollows = false;
  emergencies$: Subscription;
  mapReadySub$: Subscription;
  emergenciesSub$: Subscription;

  constructor(
    private afd: AngularFireDatabase,
    private afs: AngularFirestore,
    private afMessaging: AngularFireMessaging,
    private angularFireStorage: AngularFireStorage,
    private modalController: ModalController,
    public shellComponent: ShellComponent,
    public platform: Platform,
    public authenticationService: AuthenticationService,
    public apiService: ApiService
  ) {}

  ngOnInit() {
    try {
      if (!this.platform.is('mobileweb')) {
        //this.initNotifications();
      }
    } catch (error) {}
    try {
      if (this.shellComponent.user.role != 'admin') {
        this.agmComponent.map.remove();
        this.subscribeEmergency();
        this.subscribeFollows();
      } else {
        setTimeout(() => {
          this.agmComponent.postHomeMapping();
          this.subscribeEmergency();
          this.subscribeFollows();
        }, 2000);
      }
    } catch (error) {}
  }

  /*   initNotifications() {
    // Request permission to use push notifications
    // iOS will prompt user and return if they granted permission or not
    // Android will just grant without prompting
    PushNotifications.requestPermission().then((result: { granted: any }) => {
      if (result.granted) {
        // Register with Apple / Google to receive push via APNS/FCM
        PushNotifications.register();
      } else {
        // Show some error
      }
    });

    // On success, we should be able to receive notifications
    PushNotifications.addListener('registration', (token: PushNotificationToken) => {
      console.log('Push registration success, token: ' + token.value);
      this.afs.doc('wrUsers/' + this.shellComponent.user.token).update({
        deviceToken: token.value
      });
    });

    // Some issue with our setup and push will not work
    PushNotifications.addListener('registrationError', (error: any) => {
      console.log('Error on registration: ' + JSON.stringify(error));
    });

    // Show us the notification payload if the app is open on our device
    PushNotifications.addListener('pushNotificationReceived', (notification: PushNotification) => {
      console.log('Push received: ' + JSON.stringify(notification));
    });

    // Method called when tapping on a notification
    PushNotifications.addListener(
      'pushNotificationActionPerformed',
      (notification: PushNotificationActionPerformed) => {
        console.log('Push action performed: ' + JSON.stringify(notification));
      }
    );

    this.createChannel();
  } */

  /*   createChannel() {
    PushNotifications.createChannel({
      description: 'Emergency Notifications for Tecnotrust My Guard',
      id: 'emergency',
      importance: 5,
      lights: true,
      name: 'Emergency Notifications',
      sound: 'emergency.wav',
      vibration: true,
      visibility: 1
    })
      .then(() => {
        console.log('push channel created: ');
      })
      .catch(error => {
        console.error('push channel error: ', error);
      });
  } */

  ionViewWillLeave() {
    this.clear();
  }

  clear() {
    if (this.shellComponent.user.role == 'admin') {
      this.agmComponent.clearMap();
    }
    this.closeSubs();
  }

  closeSubs() {
    try {
      this.emergencies$.unsubscribe();
      this.mapReadySub$.unsubscribe();
    } catch (error) {}
  }

  // Fetch Data
  async subscribeEmergency() {
    if (this.shellComponent.emergencies.length > 0) {
      this.clearLayers();
      this.emergencies = this.shellComponent.emergencies;
      this.emergencies.forEach((emergency: Emergency) => {
        this.addEmergency(emergency);
      });
    }

    this.emergenciesSub$ = this.shellComponent.sendEmergencies$.subscribe(() => {
      if (this.emergencies.length > 0) {
        this.clearLayers();
      }
      this.emergencies = this.shellComponent.emergencies;
      this.emergencies.forEach((emergency: Emergency) => {
        this.addEmergency(emergency);
      });
    });
  }

  clearLayers() {
    if (this.shellComponent.user.role == 'admin') {
      this.agmComponent.clearHome();
    }
  }

  addEmergency(data: Emergency) {
    if (this.shellComponent.user.role == 'admin') {
      this.agmComponent.singleHomePost(data);
    }
  }

  async refreshMap() {
    const token = await this.authenticationService.getTokenid(false);
    console.log(token);

    if (this.shellComponent.user.role == 'admin') {
      //this.mapComponent.refreshMap();
    }

    /*    

DELETE STORE PRODUCTS

const ref = await this.afs
      .collection(`users`)
      .snapshotChanges()
      .pipe(take(1))
      .subscribe(async users => {
        for (let index = 0; index < users.length; index++) {
          const element = users[index].payload.doc.data();
          element['id'] = users[index].payload.doc.id;

          if (element['config']) {
            if (element['config']['store']) {
              console.log('has', element['id']);
              await this.afs.doc(`users/${element['id']}`).update({ config: { store: null } });
            }
          }
        }
      }); */

    /* console.log(this.agmComponent.agebs.data.length);
    let count = 0; */

    // DELETE CURRENT
    /* const actualref = await this.afs
      .collection('risk', ref => ref.where('test', '==', false))
      .get()
      .toPromise();

    for (let index = 0; index < actualref.docs.length; index++) {
      const element = actualref.docs[index].data();
      const id = actualref.docs[index].id;

      await this.afs.doc(`risk/${id}`).delete();
    } */

    //UPLOAD NEWS
    /* for (let index = 0; index < 10; index++) {
      const single = this.agmComponent.agebs.data[index];
      const date = firestore.Timestamp.now();
      if (single.risk) {
        if (single.risk.actual_risk) {
          if (single.risk.actual_risk > 4) {
            console.log(single.cvegeo);
            //count = count + 1;

            const coords = JSON.stringify(single.geojson.geometry.coordinates);
            const geo =
              '{"type": "FeatureCollection","features": [{"type": "Feature","properties": {"cvegeo":"' +
              single.cvegeo +
              '"},"geometry": {"type": "Polygon","coordinates":' +
              coords +
              '}}]}';

            // const geo =
            //  '{   "type": "FeatureCollection",   "features": [     {"type": "Feature","properties": { "cvegeo": "0900200010025" },"geometry": {"type": "Polygon","coordinates": [[[-99.20294085424335, 19.51461263386431],[-99.20306837958013, 19.51414564966892],[-99.20318842997821, 19.51371448975239],[-99.20322205006163, 19.51361872035292],[-99.20335319970553, 19.51327237005861],[-99.20361765958499, 19.51284835031679],[-99.20389598213733, 19.51241726132224],[-99.20436702998244, 19.51185424773415],[-99.2044021387619, 19.51179869127682],[-99.20452686049994, 19.51173883081567],[-99.2046146296158, 19.51170297017615],[-99.20476670921907, 19.51168487911819],[-99.2048335819608, 19.51168447840382],[-99.20524972066664, 19.51168332130704],[-99.20537012022116, 19.51168701980145],[-99.20546096982883, 19.51168495028685],[-99.20558697953975, 19.51169976969857],[-99.20611417964402, 19.5116974496298],[-99.20657993966532, 19.51169151968805],[-99.20763076998854, 19.51160402968174],[-99.20796381959086, 19.51155624987559],[-99.20827375033329, 19.51152597023325],[-99.2083790300964, 19.51148594015704],[-99.20866884971556, 19.51134145031135],[-99.20912853981088, 19.5111149099827],[-99.20969182959487, 19.51173235019895],[-99.20967464925766, 19.51175515828147],[-99.20966147561366, 19.5117726480342],[-99.20964048505408, 19.51180051434573],[-99.20963644297407, 19.51180588005286],[-99.20962934031722, 19.51181531005992],[-99.20949616978545, 19.51199207968398],[-99.20940564987941, 19.51215025039447],[-99.20938184999926, 19.51219182008556],[-99.20931602990329, 19.51230680007315],[-99.20925754036556, 19.51240902011984],[-99.20925500424252, 19.51241141932117],[-99.20919468029601, 19.51246848000045],[-99.20907812140628, 19.5125787626142],[-99.2090732197075, 19.51258340012589],[-99.20897048025724, 19.51268063014808],[-99.20886074417918, 19.51274896078078],[-99.20870599063227, 19.51284532311447],[-99.20852372044983, 19.51295881961783],[-99.20814383005181, 19.51319537973366],[-99.20809509032237, 19.51321816967814],[-99.20712929025717, 19.51366962017613],[-99.2070161197899, 19.51373145983817],[-99.20659831980096, 19.51395977975675],[-99.20617415026506, 19.51419157971188],[-99.2059190297306, 19.51433099971549],[-99.20580961974386, 19.51440625003875],[-99.20552278039506, 19.51460351026401],[-99.20523724976384, 19.51479987976663],[-99.2051401800651, 19.51485754959512],[-99.20496051997114, 19.51496430971928],[-99.20467164967798, 19.51513596975005],[-99.20433506040014, 19.51503419966999],[-99.20390657955265, 19.51490463042186],[-99.20353151975398, 19.51479123042917],[-99.20323260676614, 19.51470084939649],[-99.20294131021289, 19.51461277008071],[-99.20294085424335, 19.51461263386431]]]}}   ] }';

            console.log(JSON.stringify(geo));
            const data = {
              color: '#cc3232',
              geojson: geo,
              level: single.risk.actual_risk,
              levelId: 'very_high',
              shape: 'geojson',
              type: 'geojson',
              test: false,
              timestamp: date
            };

            await this.afs.collection(`risk`).add(data);
          }
        }
      }
    } */

    //console.log(count);

    /* 
    
    get agebs risk

    console.log(this.agmComponent.agebs.data.length);
    for (let index = 0; index < this.agmComponent.agebs.data.length; index++) {
      const single = this.agmComponent.agebs.data[index];
      const risk = await this.apiService.getRisk(single.cvegeo);
      this.agmComponent.agebs.data[index]['risk'] = risk['data'][0];
    }

    console.log(JSON.stringify(this.agmComponent.agebs)); 
    
    */

    /* 
                       
                       SEARCH AND SET AVATAR VARIABLES
                       
                       
                       let names = [
      'AvataresFinalZAFE-06',
      'AvataresFinalZAFE-07',
      'AvataresFinalZAFE-08',
      'AvataresFinalZAFE-09',
      'AvataresFinalZAFE-10',
      'AvataresFinalZAFE-11',
      'AvataresFinalZAFE-12',
      'AvataresFinalZAFE-13',
      'AvataresFinalZAFE-14',
      'AvataresFinalZAFE-15',
      'AvataresFinalZAFE-16',
      'AvataresFinalZAFE-17',
      'AvataresFinalZAFE-18',
      'AvataresFinalZAFE-19',
      'AvataresFinalZAFE-20',
      'AvataresFinalZAFE-21',
      'AvataresFinalZAFE-22',
      'AvataresFinalZAFE-23',
      'AvataresFinalZAFE-24',
      'AvataresFinalZAFE-25'
    ];

    for (let index = 0; index < names.length; index++) {
      const element = names[index];

      const urlgreen = await this.angularFireStorage
        .ref(`/assets/img/avatars/colors/${element}-green.png`)
        .getDownloadURL()
        .toPromise();
      const urlyellow = await this.angularFireStorage
        .ref(`/assets/img/avatars/colors/${element}-yellow.png`)
        .getDownloadURL()
        .toPromise();
      const urlred = await this.angularFireStorage
        .ref(`/assets/img/avatars/colors/${element}-red.png`)
        .getDownloadURL()
        .toPromise();

      const ref = this.afs.collection(`avatar`, ref => ref.where('id', '==', index));
      const id = (await ref.get().toPromise()).docs[0].id;

      const variables = {
        variables: {
          green: urlgreen,
          yellow: urlyellow,
          red: urlred
        }
      };

      await this.afs.doc(`avatar/${id}`).update(variables);
    } */

    /* 
    
    RESET AVATARS */

    /* let avatars = [];
    const types: string[] = [];
    types.push('familiar');

    try {
      const data = await this.afs
        .collection('avatar', ref => ref.where('type', 'array-contains-any', types).orderBy('id', 'asc'))
        .get()
        .toPromise();
      for (let index = 0; index < data.docs.length; index++) {
        const element = data.docs[index].data();
        avatars.push(element);
      }
    } catch (error) {}

    console.log(avatars);

    for (let index = 0; index < avatars.length; index++) {
      const avatar = avatars[index];
      const userRef = await this.afs
        .collection('users', ref => ref.where('avatar.id', '==', avatar.id))
        .get()
        .toPromise();

      for (let index = 0; index < userRef.docs.length; index++) {
        const element = userRef.docs[index].id;
        const datas = userRef.docs[index].data();
        console.log('element', element, datas.avatar.url);

        await this.afs.doc(`users/${element}`).set(
          {
            avatar: {
              url: avatar.url
              //color: avatar.variables.green
            }
          },
          { merge: true }
        );
      }
    } */
  }

  // Fetch Data

  async subscribeFollows() {
    if (this.shellComponent.follows.length > 0) {
      this.follows = this.shellComponent.follows;

      this.follows.forEach((emergency: Emergency) => {
        this.follows = this.shellComponent.follows;
      });
    }

    this.emergenciesSub$ = this.shellComponent.sendEmergencies$.subscribe(() => {
      this.follows = this.shellComponent.follows;

      this.follows.forEach((emergency: Emergency) => {
        this.follows = this.shellComponent.follows;
      });
    });
  }

  swapView() {
    this.listEmergencies = !this.listEmergencies;
    this.shellComponent.switch = this.listEmergencies;
  }

  async acceptTrack() {
    const modal = await this.modalController.create({
      component: FollowsheetComponent
    });
    return await modal.present();
  }
}
